import React from "react";
import Tr from "./Tr";

/**
 * Table Component
 * Displays distro presets in a table format
 */
const Table = ({
  data,
  onEdit,
  onDelete,
  isAllowedToEditOrDelete,
  reddevcut,
}) => {
  return (
    <div className="form-container">
      <table className="table">
        <thead>
          <tr>
            <th className="first-col col-numeric-date">Order</th>
            <th className="col-numeric-date">Name</th>
            <th className="col-numeric-date">Beneficiary</th>
            <th className="col-numeric-date">Sponsor</th>
            <th className="col-numeric-date">Artist</th>
            <th className="col-options">Options</th>
          </tr>
        </thead>

        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan={7}>No data found....</td>
            </tr>
          ) : (
            data.map((item, index) => (
              <Tr
                key={item.distro_preset_id}
                order={index}
                item={item}
                onEdit={onEdit}
                onDelete={onDelete}
                isAllowedToEditOrDelete={isAllowedToEditOrDelete}
                reddevcut={reddevcut}
              />
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
